//TODO Change as texas holdem logic
export const MessagesList = {
  2: { parts_length: 0 },
  59: ['string'],
  60: {
    parts_length: 1,
    data: [{ name: 'settings', type: 'string' }],
  },
  61: ['string', 'string'],

  64: ['string', 'number', 'number'],
  65: {
    parts_length: 8,
    data: [
      { name: 'rolled', type: 'array', delimeter: ';' },
      { name: 'balance', type: 'number' },
      { name: 'totalWin', type: 'number' },
      { name: 'winCoeff', type: 'number' },
      { name: 'betAmount', type: 'number' },
      { name: 'bet_id', type: 'number' },
      { name: 'mode', type: 'string' },
      { name: 'rows', type: 'string' },
    ],
  },
  66: {
    parts_length: 12,
    data: [
      { name: 'bet_id', type: 'string' },
      { name: 'user_name', type: 'base64' },
      { name: 'user_id', type: 'string' },
      { name: 'currency', type: 'int' },
      { name: 'bet', type: 'number' },
      { name: 'profit', type: 'number' },
      { name: 'roll', type: 'number' },
      { name: 'up', type: 'number' },
      { name: 'number', type: 'number' },
      { name: 'time', type: 'string' },
      { name: 'wintype', type: 'int' },
      { name: 'history', type: 'int' },
    ],
  },
  67: {
    parts_length: 13,
    data: [
      { name: 'round_id', type: 'string' },
      { name: 'user_name', type: 'base64' },
      { name: 'user_id', type: 'string' },
      { name: 'betAmount', type: 'number' },
      { name: 'winAmount', type: 'number' },
      { name: 'winCoef', type: 'number' },
      { name: 'currency', type: 'string' },
      { name: 'bigWin', type: 'int' },
      { name: 'bet_id', type: 'int' },
      { name: 'history', type: 'int' },
      { name: 'time', type: 'string' },
      { name: 'gameplay', type: 'string' },
      { name: 'sessionNo', type: 'string' },
    ],
  },
  69: ['number'],
  70: {
    parts_length: 1,
    data: [{ name: 'jackpot', type: 'string' }],
  },
  71: {
    parts_length: 9,
    data: [
      { name: 'totalWin', type: 'number' },
      { name: 'currencyId', type: 'string' },
      { name: 'username', type: 'base64' },
      { name: 'userId', type: 'string' },
      { name: 'winPercent', type: 'number' },
      { name: 'history', type: 'int' },
      { name: 'totalAmount', type: 'number' },
      { name: 'date', type: 'string' },
      { name: 'bet_id', type: 'string' },
    ],
  },
  90: {
    parts_length: 1,
    data: [{ name: 'errorCode', type: 'int' }],
  },
  101: ['string'],
  116: ['string'],

  119: {
    parts_length: 8,
    data: [
      { name: 'server_seed_SHA256', type: 'string' },
      { name: 'client_seed', type: 'string' },
      { name: 'nonce', type: 'int' },
      { name: 'old_server_seed', type: 'string' },
      { name: 'old_server_seed_SHA256', type: 'string' },
      { name: 'old_client_seed', type: 'string' },
      { name: 'old_nonce', type: 'int' },
      // { name: 'sessionNo', type: 'string' },
      { name: 'next_server_seed_SHA256', type: 'string' },
    ],
  },
  121: {
    parts_length: 6,
    data: [
      { name: 'statType', type: 'string' },
      { name: 'betsCount', type: 'int' },
      { name: 'winsCount', type: 'int' },
      { name: 'payIn', type: 'number' },
      { name: 'payOut', type: 'number' },
      { name: 'chart', type: 'array', delimeter: ';' },
    ],
  },
  122: {},
  123: {
    parts_length: 2,
    data: [
      { name: 'balance', type: 'string' },
      { name: 'currency', type: 'string' },
    ],
  },
  124: ['string', 'string'],
  125: ['string'],
  126: {},

  63: {
    parts_length: 12,
    data: [
      { name: "serverSeedSHA256", type: "string" },
      { name: "clientSeed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "balance", type: "number" },
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      {
        name: "game_settings",
        type: "objects",
        delimeter: ";",
        parts_length: 2,
        obj: [
          { name: "coefs", type: "array", delimeter: ":" }
        ],
      },
      { name: "minBet", type: "number" },
      { name: "maxBet", type: "number" },
      { name: "currency", type: "string" },
      { name: "precision", type: "number" },
      { name: "next_server_seed_SHA256", type: "string" },
    ],
  },
  117: {
    parts_length: 24,
    data: [
      { name: "user_id", type: "string" },
      { name: "user_name", type: "base64" },
      { name: "bet_id", type: "int" },
      { name: "round_id", type: "string" },
      { name: "betAmount", type: "number" },
      { name: "totalWin", type: "number" },
      { name: "currency", type: "string" },
      { name: "winCoef", type: "number" },
      { name: "bigWin", type: "int" },
      { name: "server_seed", type: "string" },
      { name: "server_seed_SHA256", type: "string" },
      { name: "client_seed", type: "string" },
      { name: "nonce", type: "int" },
      { name: "date", type: "string" },
      { name: "state", type: "int" },
      { name: "cards", type: "array", delimeter: ";" },
      { name: "playerWinType", type: "int" },
      { name: "playerWinPositions", type: "array", delimeter: ";" },
      { name: "dealerWinType", type: "int" },
      { name: "dealerWinPositions", type: "array", delimeter: ";" },
      {
        name: "ante",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      },
      {
        name: "raise",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      },
      {
        name: "turn",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      },
      {
        name: "river",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      }
    ],
  },
  127: {
    parts_length: 15,
    data: [
      { name: "currentBetId", type: "string" },
      { name: "balancebefore", type: "number" },
      { name: "balance", type: "number" },
      { name: "state", type: "int" },
      { name: "anteraise", type: "number" },
      { name: "totalWin", type: "number" },
      { name: "cards", type: "array", delimeter: ";" },
      { name: "playerWinType", type: "int" },
      { name: "playerWinPositions", type: "array", delimeter: ";" },
      { name: "dealerWinType", type: "int" },
      { name: "dealerWinPositions", type: "array", delimeter: ";" },
      {
        name: "ante",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      },
      {
        name: "raise",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      },
      {
        name: "turn",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      },
      {
        name: "river",
        type: "objects",
        delimeter: ":",
        parts_length: 3,
        obj: [
          { name: "bet", type: "number" },
          { name: "win", type: "number" },
          { name: "mult", type: "number" }
        ],
      }
    ]
  },
}
